export const OPT =
  'group flex min-h-12 w-full items-stretch overflow-hidden rounded-plate border-2 border-plate-line bg-transparent p-0 text-left text-t15 leading-[1.4] font-medium text-foreground [transition:background_0.15s,border-color_0.15s,color_0.15s,transform_0.11s_cubic-bezier(0.22,1,0.36,1)] disabled:cursor-default ' +
  'data-[verdict=correct]:border-ok data-[verdict=correct]:bg-ok-tint ' +
  'data-[verdict=wrong]:border-bad data-[verdict=wrong]:bg-bad-tint ' +
  'data-[verdict=dim]:text-faint ' +
  'data-[verdict=picked]:border-primary data-[verdict=picked]:bg-acc-pick';

export const OPT_BAR =
  'w-1.5 flex-none bg-transparent group-data-[verdict=correct]:bg-ok group-data-[verdict=wrong]:bg-bad group-data-[verdict=picked]:bg-primary';

export const OPT_TEXT =
  'min-w-0 flex-1 self-center px-3.5 py-2 text-pretty [overflow-wrap:anywhere]';

export const OPT_MARK =
  'flex-none self-center py-2 pr-3.5 text-t14 font-extrabold text-faint group-data-[verdict=correct]:text-ok group-data-[verdict=wrong]:text-bad';

export function focusOnMount(el: HTMLElement | null): void {
  el?.focus({ preventScroll: true });
}

export function optionVerdict(
  answered: boolean,
  isCorrect: boolean,
  isSelected: boolean,
): string | undefined {
  if (!answered) return undefined;
  if (isCorrect) return 'correct';
  if (isSelected) return 'wrong';
  return 'dim';
}
